import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class OrganizationsApi {
  static getOrganizations = () => {
    return axios.get(`${API_BASE_URL}/getOrganizations`);
  };

  static getFacilitiesByOrganization = (organizationId) => {
    const params = new URLSearchParams();
    if (organizationId) {
      params.append('organization_id', organizationId);
    }

    return axios.get(`${API_BASE_URL}/facilitiesPro?${params.toString()}`);
  };

  static updateManagedAccountMembership = (
    organizationId,
    managed,
    confirmUnassignment = false,
  ) => {
    return axios.put(
      `${API_BASE_URL}/organizations/${organizationId}/managed-account-membership`,
      { managed, confirm_unassignment: confirmUnassignment },
    );
  };

  static getOrganizationFeatures = async (organizationId) => {
    return (
      await axios.get(
        `${API_BASE_URL}/organization/features?${
          organizationId && `organizationId=${organizationId} `
        }`,
      )
    ).data;
  };

  static updateOrganizationFeatures = (organizationId, features) => {
    return axios.post(
      `${API_BASE_URL}/admin/organization/features?organizationId=${organizationId}`,
      features,
    );
  };

  static getFacilityPortalHandoff = async (organizationId) => {
    return (
      await axios.post(
        `${API_BASE_URL}/admin/facility-portal-handoff/${organizationId}`,
      )
    ).data;
  };
}
